export function formatNumber(number: number) {
  return new Intl.NumberFormat('fi').format(number);
}

export function formatPercent(value: number) {
  return Intl.NumberFormat('fi', { style: 'percent', maximumFractionDigits: 0 }).format(value);
}
